// @ts-strict-ignore
import type { TicketCreateParams } from 'interfaces/api/ticket';
import type { TicketStatus } from 'interfaces/entities/ticket';

import { BaseApi } from '../base-api';

export interface ICreateTicketResponse {
  id: string;
  assignee?: { id: string; name: string; account_id: string };
  events: {
    author: {
      id: string;
      name: string;
      type: string;
      account_id: string;
    };
    date: string;
    is_private: boolean;
    message: string;
    type: string;
    source: { type: string; url?: string };
  }[];
  requester: {
    mail: string;
    name: string;
    ip: string;
  };
  groups: { id: number; name: string; inherited: boolean }[];
  status: TicketStatus;
  subject: string;
  modified: string;
  source: { type: string; url?: string; id?: string };
  opened: [{ from: string }];
  firstResponse: unknown;
  tags: string[];
  rate: 'not_rated';
  date: string;
  is_sample: boolean;
  currentGroup: { id: number; name: string; inherited: boolean };
}

function getCreateTicketParams(params: TicketCreateParams): FormData {
  const data = new FormData();
  data.append('requester[mail]', params.requester.mail);
  if (params.requester.name) {
    data.append('requester[name]', params.requester.name);
  }
  if (params.chatId) {
    data.append('chat_id', params.chatId);
  }
  if (params.subject) {
    data.append('subject', params.subject);
  }
  if (params.message) {
    data.append('message', params.message);
  }
  if (params.assigneeId) {
    data.append('assignee[id]', params.assigneeId);
  }
  if (params.groupIds) {
    if (params.groupIds.length === 1) {
      data.append('group[]', params.groupIds[0]);
    } else {
      params.groupIds.forEach((groupId) => {
        data.append('group', groupId);
      });
    }
  }
  if (params.sourceType) {
    data.append('source[type]', params.sourceType);
  }
  if (params.attachments) {
    params.attachments.forEach((attachment) => {
      data.append('attachments', attachment, attachment.name);
    });
  }

  return data;
}

export class TicketApi extends BaseApi {
  protected readonly prefix = 'tickets';
  protected readonly passAppVersionHeader = true;

  createTicket = (params: TicketCreateParams) => this.post('', getCreateTicketParams({ ...params }));
}
